import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose</span> Us as Your Trusted WordPress Design
              Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              Wondering why we stand out as a top-notch WordPress development
              company? That’s because we turn ideas into impactful websites!
            </p>
            <p>
              Here’s why you should choose us as your custom WordPress
              development company:
            </p>
            <ul>
              <li>
                <strong>Proven Expertise:</strong> With years of experience,
                we've honed our skills in WordPress design, ensuring top-notch
                solutions that resonate with your brand.
              </li>
              <li>
                <strong>Custom Designs:</strong> Designs customized to your
                needs, we go beyond templates, delivering unique and impactful
                solutions for an effective online presence.
              </li>
              <li>
                <strong>Client-Centric Approach:</strong> We collaborate
                closely, understanding your vision to create WordPress designs
                that exceed expectations and drive success.
              </li>
              <li>
                <strong>Smooth Integration:</strong> Our designs smoothly
                integrate with WordPress functions, providing visual appeal and
                a user-friendly browsing experience for visitors.
              </li>
            </ul>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let's craft your standout WordPress site today{" "}
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/wordpress/Why-Choose.webp"
              alt="tekrevol_android"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
